<template>
    <Top />
    <!-- Spinner Start -->
    <!-- Spinner Start -->
    <div id="spinner" style="background-color: #DCDCDC;z-index: 999999;opacity: 0.5;" v-if="halamanloading"
        class="show position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <img src="../../../../src/assets/images/logo.png" height="40">&nbsp;
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
        </div>
        &nbsp;<span class="sr-only text-danger" style="font-weight: bolder;">..CISP System Loading...</span>
    </div>
    <!-- Spinner End -->
    <section class="hero-section d-flex justify-content-center align-items-center" id="section_1"
        :style="'background-image:url(' + folder_slider + foto_background + ') !important;'">
        <div class="section-overlay"></div>
        <svg xmlns="" viewBox="0 5 1440 320">
            <rect x="0" y="0" width="2980" height="100" fill="#3D405B" />
        </svg>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 mb-5 mb-lg-0">
                    <h5 class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ namaku }}&nbsp;</span>
                        <span v-else>{{ nama_eng }}&nbsp;</span>
                    </h5>
                    <h1 class="cd-headline rotate-1 text-white mb-4 pb-2">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ text_label }}&nbsp;</span>
                        <span v-else>{{ text_label_eng }}&nbsp;</span>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')" class="cd-words-wrapper">
                            <template v-for="(dataketerangan, urutketerangan) in keterangan" :key="urutketerangan">
                                <b :class="[((urutketerangan == 0) ? 'is-visible' : '')]">{{ dataketerangan.nama }}</b>
                            </template>
                        </span>
                        <span v-else class="cd-words-wrapper">
                            <template v-for="(dataketerangan_eng, urutketerangan_eng) in keterangan_eng"
                                :key="urutketerangan_eng">
                                <b :class="[((urutketerangan_eng == 0) ? 'is-visible' : '')]">{{ dataketerangan_eng.nama
                                    }}</b>
                            </template>
                        </span>
                    </h1>
                </div>
            </div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fill-opacity="1"
                d="M0,224L34.3,192C68.6,160,137,96,206,90.7C274.3,85,343,139,411,144C480,149,549,107,617,122.7C685.7,139,754,213,823,240C891.4,267,960,245,1029,224C1097.1,203,1166,181,1234,160C1302.9,139,1371,117,1406,106.7L1440,96L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z">
            </path>
        </svg>
    </section>
    <section class="about-section">
        <div class="container">
            <div class="row g-4 justify-content-center">
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldataprogres" style="font-size: small;">
                            <thead>
                                <tr>
                                    <th style="width: 600px;">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Rencana Aksi Gender
                                        </span>
                                        <span v-else>
                                            Gender Action Plan
                                        </span>
                                    </th>
                                    <th style="width: 200px;">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Kemajuan hingga saat ini
                                        </span>
                                        <span v-else>
                                            Progress to date
                                        </span>
                                    </th>
                                    <th style="width: 200px;">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Masalah dan Tantangan
                                        </span>
                                        <span v-else>
                                            Issues and Challenges
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                <tbody>
                                    <tr>
                                        <td colspan="3" class="total">
                                            {{ datalist.Komponen }}
                                        </td>
                                    </tr>
                                    <template v-for="(datalist2, urutlist2) in datalist.DetailKomponen"
                                        :key="urutlist2">
                                        <tr>
                                            <td>
                                                <span class="text-danger">{{ datalist2.SubKomponen }}</span>
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <template v-for="(datalist3, urutlist3) in datalist2.Detail" :key="urutlist3">
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')"
                                                        class="text-success">
                                                        <span v-html="datalist3.levelkomponen"></span>
                                                    </span>
                                                    <span v-else class="text-success">
                                                        <span v-html="datalist3.levelkomponen_eng"></span>
                                                    </span>
                                                    <br><br>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        <span v-html="datalist3.level1"></span>
                                                    </span>
                                                    <span v-else>
                                                        <span v-html="datalist3.level1_eng"></span>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        {{ datalist3.kemajuan }}
                                                    </span>
                                                    <span v-else>
                                                        {{ datalist3.kemajuan_eng }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        <span v-html="datalist3.keterangan"></span>
                                                    </span>
                                                    <span v-else>
                                                        <span v-html="datalist3.keterangan_eng"></span>
                                                    </span>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </tbody>
                            </template>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
        </div>
    </section>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import 'vue3-carousel/dist/carousel.css'
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts, BarChartMonitoringPVProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datatahun: [],
            totalowp: 0,
            totalawp: 0,
            sisapagu: 0,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            project_id: process.env.VUE_APP_PROJECT_ID,
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),

            namaku: '',
            nama_eng: '',
            text_label: '',
            text_label_eng: '',
            keterangan: [],
            keterangan_eng: [],
            folder_slider: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=',
            foto_background: '',
        };
    },
    methods: {
        async ambildata() {
            const mainAPI3 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI3.get("parastapainnovation-GetSlider?random=" + random + "&project_id=" + this.project_id + "&id=13").then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataslider = [];
                        this.dataslider = Response.data.content.data;
                        this.namaku = Response.data.content.data[0].nama;
                        this.nama_eng = Response.data.content.data[0].nama_eng;
                        this.text_label = Response.data.content.data[0].text_label;
                        this.text_label_eng = Response.data.content.data[0].text_label_eng;
                        this.keterangan = Response.data.content.data[0].keterangan;
                        this.keterangan_eng = Response.data.content.data[0].keterangan_eng;
                        this.foto_background = '';
                        this.foto_background = Response.data.content.data[0].filenya_slider;
                        this.halamanloading = false;
                    }
                    else {
                        this.dataslider = [];
                        this.foto_background = '';
                        this.halamanloading = false;
                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.foto_background = '';
                this.dataslider = [];
                this.halamanloading = false;
            });

            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-GESIAP?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    this.colspan = Response.data.jumlahtahun;
                    this.datamaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.halamanloading = true;
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.datatahun = Response.data.tahun;
                        //alert(this.datatahun);

                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.datamaster = [];
                        this.datatahun = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                this.datatahun = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style>
.carousel__prev,
.carousel__next {
    box-sizing: content-box;
    border: 5px solid #0055aa;
    border-radius: 40px;
    background-color: #0055aa;
    color: aliceblue;
    height: 50px;
    width: 50px;
}

/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 0.9);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 0.9);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 90%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}
</style>